import Reveal from '@/components/base/Reveal';
import { contactChannels } from '@/mocks/contactData';

const accentClasses: Record<string, string> = {
  primary: 'bg-primary-100 text-primary-700',
  accent: 'bg-accent-100 text-accent-700',
  secondary: 'bg-secondary-100 text-secondary-700',
};

export default function ContactChannels() {
  return (
    <section className="w-full bg-background-50 py-14 md:py-16">
      <div className="w-full px-4 md:px-8">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {contactChannels.map((channel, index) => (
            <Reveal key={channel.id} delay={index * 90}>
              <div className="h-full flex flex-col rounded-lg border border-background-200 bg-background-50 p-6">
                <span
                  className={`w-11 h-11 flex items-center justify-center rounded-full ${
                    accentClasses[channel.accent] || accentClasses.primary
                  }`}
                >
                  <i className={`${channel.icon} text-xl`}></i>
                </span>
                <h3 className="font-heading mt-4 text-base font-semibold text-foreground-950">{channel.title}</h3>
                <ul className="mt-3 space-y-1 flex-1">
                  {channel.lines.map((line) => (
                    <li key={line} className="text-sm leading-relaxed text-foreground-600">
                      {line}
                    </li>
                  ))}
                </ul>
                <a
                  href={channel.actionHref}
                  target={channel.actionHref.startsWith('http') ? '_blank' : undefined}
                  rel={channel.actionHref.startsWith('http') ? 'noopener noreferrer' : undefined}
                  className="mt-5 inline-flex items-center gap-2 text-sm font-semibold text-primary-700 hover:text-primary-600 transition-colors cursor-pointer"
                >
                  {channel.actionLabel}
                  <i className="ri-arrow-right-line text-base"></i>
                </a>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}